import React from 'react';
import { useSelector } from 'react-redux';

import SmartImage from 'dpl/components/SmartImage';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import { breedLocationInfoResourceDefinition } from 'dpl/shared/utils/tptConnectResourceDefinitions';

import dogComputerSvg from 'dpl/assets/dog_computer.svg';

import BreedLocationInfoSkeleton from './BreedLocationInfoSkeleton';

export default function BreedLocationInfo() {
  const { breedId, citySlug, stateSlug } = useSelector(
    ({ server }: any) => server
  );

  const { isFetching, value } = useResourceQuery(
    breedLocationInfoResourceDefinition({ breedId, citySlug, stateSlug })
  );

  const breedInfo = value.data?.breed_info;

  if (isFetching) {
    return <BreedLocationInfoSkeleton />;
  }

  if (!breedInfo) return null;

  return (
    <div className="BreedLocationInfo stone-700 bg-sand">
      <div className="container-xxl">
        <div className="row pv10 pv16-md">
          <div className="col-12 col-md-6">
            <h5 className="dn db-ns font-24 md:font-48 mb8-md">
              About Good Dog
            </h5>
            <div className="tc tl-l">
              <SmartImage src={dogComputerSvg} width="290px" height="217px" />
            </div>
            <h5 className="db dn-ns font-24 md:font-48 mb6 mt8">
              About Good Dog
            </h5>
          </div>
          <div className="col-12 col-md-6">
            <p className="font-18 md:font-24 md:font-serif ph6-xl">
              {breedInfo}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
